import React from 'react'
import { useParams } from 'react-router'
import movies from '../movies';
import Header from './Header';
import Stars from './Stars';
const MovieDescription = () => {
    const movieId = useParams().id;
    const currentMovie = movies.find(movie=>movie.id===+movieId);
    const [preferidos, setPreferidos] = React.useState(() => {
        const localList = localStorage.getItem('preferidos')
        return localList ? JSON.parse(localList) : []
    });
    React.useEffect(()=>{
        window.localStorage.setItem('preferidos', JSON.stringify(preferidos))
    },[preferidos]);
    const isPreferido = preferidos.filter(preferido=>preferido.id===+movieId).length>1
    return (<>
            <Header isTransparent={true} />
            <div className="movieDescription">
                <div className="movieDescription__hero">
                    <div className="movieDescription__hero__wrapper"></div>
                    <img src={currentMovie.large} alt={currentMovie.descricao} />
                </div>
                <div className="movieDescription__texto">
                    <div className="movieDescription__texto__title">
                        <div>
                            <h1>{currentMovie.nome}</h1>
                            <Stars n={currentMovie.stars} />
                        </div>
                        <div className="movieDescription__texto__title__controls">
                            <i className="fa fa-plus"></i>  
                            <i className={`fa fa-heart ${isPreferido ? 'loveit': ''}`} onClick={()=>{
                                if(!isPreferido){
                                    setPreferidos([...preferidos, {id: currentMovie.id}, {id: currentMovie.id}])
                                    window.alert(`${currentMovie.nome} adicionado aos preferidos`)
                                }else{
                                    setPreferidos(preferidos.filter(preferido=>preferido.id!==+movieId))
                                    window.alert(`${currentMovie.nome} removido dos preferidos`)
                                }
                            }
                            }></i>  
                        </div>
                    </div>
                    <p>
                        {currentMovie.descricao}
                    </p>
                </div>
                {
                    !currentMovie.isSeries ? '' : <div className="movieDescription__episodios">
                        <div className="movieDescription__episodios__title">
                            <h2>Episódios</h2>
                            <select name="temporadas" id="#">
                                <option value="temp1">1ª Temporada</option>
                            </select>
                        </div>
                        <ul className="episodiosLista">
                            {currentMovie.episodios.temp1.map((episodio, index) => {
                                return (
                                <li key={index}>
                                        <label htmlFor={'epi'+index}>
                                            <span className="episodiosLista__num">
                                                {index+1}
                                            </span>
                                            {' '+episodio}
                                        </label>
                                        <input type="checkbox" name="episodeCheck" id={'epi'+index} />
                                        {console.log(episodio)}
                                </li>
                                )
                            })}
                        </ul>
                    </div>
                }
            </div>
        </>
    )
}

export default MovieDescription
